import { StagesData } from '../../types';
import { AxiosPrivate } from '../../utils';

interface IData {
  data: StagesData[];
}

class StagesApi {
  private static instance: StagesApi;

  public static getInstance(): StagesApi {
    if (!StagesApi.instance) {
      StagesApi.instance = new StagesApi();
    }
    return StagesApi.instance;
  }

  getStages = () => {
    return AxiosPrivate.get<IData>('v1/stages');
  };
}

export const stagesApi = StagesApi.getInstance();
